import React from 'react';
import { useAmoebaConfig } from '../../hooks/useAmoebaConfig';
import { settingsGroups } from '../../navigation/modules';
import ModuleCard from '../../components/ModuleCard';
import PageHeader from '../../components/PageHeader';

/** HR / Admin: every setup page in one place, grouped. Only what this person may open is listed. */
const SettingsHub = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const { hasAmoeba } = useAmoebaConfig();
    const groups = settingsGroups(user, hasAmoeba);

    return (
        <div className="container section">
            <PageHeader />
            <h1 style={{ margin: '0 0 0.5rem' }}>Settings</h1>
            <p style={{ color: 'var(--text-muted)', marginTop: 0 }}>How your organisation is set up. Each part opens its own page.</p>

            {groups.length === 0 && <p style={{ color: 'var(--text-muted)' }}>There is nothing here for you to set up.</p>}

            {groups.map(g => (
                <section key={g.title} aria-label={g.title} style={{ marginTop: '2rem' }}>
                    <h2 className="module-section-title" style={{ borderLeft: '4px solid #64748b' }}>{g.title}</h2>
                    <div className="module-grid">
                        {g.items.map(m => <ModuleCard key={m.key} module={m} color="#64748b" />)}
                    </div>
                </section>
            ))}
        </div>
    );
};

export default SettingsHub;
